<template>
  <div>
    <el-dialog :visible.sync="visible" width="1400px" class="product-fee-dialog" custom-class="custom-btn" :close-on-click-modal="false" top="0">
      <div class="product-fee">
        <div class="top-box">
          <tooltip class="name1" :txt-info="formData.templateName + '——' + formData.productName"></tooltip>
          <div class="tag gray" v-if="formData.status == 1">已下架</div>
        </div>
        <div class="content">
          <div class="hd-box" v-if="commissonsData.activityName && activeName == 1">
            <span class="biaozhi">活</span>
            {{ commissonsData.activityStartTime | timeSubstr(0, 10) }} 至 {{ commissonsData.activityEndTime | timeSubstr(0, 10) }}
            {{ commissonsData.activityName }}
          </div>
          <feeTable ref="feeTable" @save="save" v-show="activeName == 1" :formData="formData"></feeTable>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import feeTable from "./feeTable";
import tooltip from "@/components/tooltip";
export default {
  data: () => ({
    activeName: '1',
    visible: false,
    loadingObj: {},
    loading: true,
    formData: {},
    commissonsData: {}
  }),
  components: {
    tooltip,
    feeTable,
  },
  mounted() {
  },
  methods: {
    open(data = {}) {
      console.log(data)
      this.formData = JSON.parse(JSON.stringify(data));
      this.commissonsData = [];
      this.$refs.feeTable && this.$refs.feeTable.setData({
        productList: []
      })
      this.activeName = '1';
      this.visible = true;
      if (this.formData.userId) {
        delete this.formData.subMechanId
      }
      this.$http({
        url: "/master/commissonTemplate/queryCommissonDataList",
        type: "put",
        params: this.formData
      }).then((res) => {
        this.commissonsData = res.data;
        this.$refs.feeTable.setData(res.data)
      });
    },
    save(list) {
      const params = {
        templateId: this.formData.templateId,
        productId: this.formData.productId,
        list,
      }
      let ajaxUrl = "/master/commissonTemplate/saveCommissonData";
      if (this.formData.subMechanId) {//配置团队费用
        ajaxUrl = "/master/commissonTemplate/saveMechanCommisson";
        params.mechanId = this.formData.subMechanId;
      }
      console.log(params);
      this.$http({
        url: ajaxUrl,
        type: "post",
        params: params
      }).then((res) => {
        this.$message.success("保存成功");
        this.visible = false;
        this.$emit("reload");
      });
    }

  },
};
</script>
<style lang="scss" scoped>
@import './productFee.scss';
</style>

